export default {
  woundGoal: {
    goalParameterList: [],
    SelectedGoal: '',
    selectedExudate: '',
    allParams: [],
  },
};
